import { StringUtility } from '@common/utils';
import { defaultTo } from 'lodash';
import { IModel, ModelRecord, schedule } from '@common/models';

export interface IHospitalScheduleTemplateModel extends IModel {
  hospitalScheduleTemplateId: number;
  hospitalId: number;
  name: string | undefined;
  isActive: boolean;
  isDefault: boolean;
  color: string | undefined;
  hospitalSchedulePreferences: schedule.EntitySchedulePreference[];
}
export class HospitalScheduleTemplateModel
  implements ModelRecord<IHospitalScheduleTemplateModel>
{
  rowVersion: string;
  hospitalScheduleTemplateId: number;
  hospitalId: number;
  name: string | undefined;
  color: string | undefined;
  isActive: boolean;
  isDefault: boolean;
  hospitalSchedulePreferences: schedule.EntitySchedulePreference[];

  constructor(init?: Partial<IHospitalScheduleTemplateModel>) {
    this.rowVersion = defaultTo(init?.rowVersion, '');
    this.hospitalScheduleTemplateId = defaultTo(
      init?.hospitalScheduleTemplateId,
      0,
    );
    this.hospitalId = defaultTo(init?.hospitalId, 0);
    this.name = StringUtility.SanitizeString(init?.name);
    this.color = StringUtility.SanitizeString(init?.color ?? '#2596be');
    this.isActive = defaultTo(init?.isActive, false);
    this.isDefault = defaultTo(init?.isDefault, false);
    this.hospitalSchedulePreferences = init?.hospitalSchedulePreferences
      ? init.hospitalSchedulePreferences.map(
          (p) => new schedule.EntitySchedulePreference(p),
        )
      : ([] as schedule.EntitySchedulePreference[]);
  }
}
